import React, { useState } from "react";
import FormFieldsLayout from "../ContactForms/common/FormBox";
import NumberFormat from "react-number-format";
import { unformatPhoneNumber } from "../../utils/text";
import { Button } from "../Buttons";
import { Input, Box, Checkbox, useToast } from "@chakra-ui/core";
import axios from "axios";

import "./style.css";

const CustomPhoneInput = React.forwardRef(({ value, ...props }: any, ref: any) => (
  <Input
    {...props}
    ref={ref}
    value={value}
    color={value ? "black" : "gray.500"}
    _placeholder={{ color: "gray.500" }}
  />
));
CustomPhoneInput.displayName = "CustomPhoneInput";

export default function DealersForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    website: "",
    physicalLocation: false,
    wholesale: false,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const toast = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhoneChange = (values: any) => {
    setFormData((prev) => ({
      ...prev,
      phone: values.formattedValue,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.post("/.netlify/functions/dealerSubmission", formData);
      toast({
        title: "Success",
        description: "Form submitted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        website: "",
        physicalLocation: false,
        wholesale: false,
      });
      setFormSubmitted(true);
    } catch (error) {
      console.error("Submission error:", error);
      toast({
        title: "Error",
        description: "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="dealers_form-container">
      <FormFieldsLayout className="dealers_form-fields_group" mb="2.9531rem">
        {!formSubmitted ? (
          <>
            <Box className="row">
              <Input
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
              <Input
                name="email"
                placeholder="Email address"
                type="email"
                isRequired
                value={formData.email}
                onChange={handleChange}
              />
            </Box>
            <Box className="row">
              <NumberFormat
                name="phone"
                type="tel"
                format="(###) ###-####"
                allowEmptyFormatting
                mask="_"
                placeholder="Phone"
                value={formData.phone}
                onValueChange={handlePhoneChange}
                customInput={CustomPhoneInput}
              />
              <Input
                name="website"
                placeholder="Website"
                value={formData.website}
                onChange={handleChange}
              />
            </Box>

            <Box className="row" display="flex" flexDir="column" mt="1rem">
              <Checkbox
                name="physicalLocation"
                isChecked={formData.physicalLocation}
                onChange={handleChange}
              >
                Physical location
              </Checkbox>
              <Checkbox
                name="wholesale"
                isChecked={formData.wholesale}
                onChange={handleChange}
              >
                Wholesale
              </Checkbox>
            </Box>

            <Box className="row" textAlign="center">
              <Button theme="primary" type="submit">
                Submit
              </Button>
            </Box>
          </>
        ) : (
          <p>Form submitted successfully!</p>
        )
      }
      </FormFieldsLayout>
    </Box>
  );
}
